import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageVisibilityService {
  private static readonly HIDDEN = 'hidden';
  private static readonly MS_HIDDEN = 'msHidden';
  private static readonly WEB_KIT_HIDDEN = 'webkitHidden';

  private readonly document = inject<Document>(DOCUMENT);

  public $onPageVisible: Observable<void>;
  public $onPageHidden: Observable<void>;
  public $onPageVisibilityChange: Observable<boolean>;

  private onPageVisibleSource = new Subject<void>();
  private onPageHiddenSource = new Subject<void>();
  private onPageVisibilityChangeSource: Subject<boolean> = new Subject<boolean>();
  private hidden: string;
  private visibilityChange: string;

  constructor() {
    this.init();
    this.listenPageVisibility();
  }

  public isPageVisible(): boolean {
    return !this.isPageHidden();
  }

  public isPageHidden(): boolean {
    return !!this.document[<keyof Document>this.hidden];
  }

  private init(): void {
    this.$onPageVisible = this.onPageVisibleSource.asObservable();
    this.$onPageHidden = this.onPageHiddenSource.asObservable();
    this.$onPageVisibilityChange = this.onPageVisibilityChangeSource.asObservable();
    if (typeof this.document[PageVisibilityService.HIDDEN] !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      this.hidden = PageVisibilityService.HIDDEN;
      this.visibilityChange = 'visibilitychange';
    } else if (typeof (<any>this.document)[PageVisibilityService.MS_HIDDEN] !== 'undefined') {
      this.hidden = PageVisibilityService.MS_HIDDEN;
      this.visibilityChange = 'msvisibilitychange';
    } else if (typeof (<any>this.document)[PageVisibilityService.WEB_KIT_HIDDEN] !== 'undefined') {
      this.hidden = PageVisibilityService.WEB_KIT_HIDDEN;
      this.visibilityChange = 'webkitvisibilitychange';
    }
  }

  private listenPageVisibility(): void {
    this.document.addEventListener(
      this.visibilityChange,
      () => {
        if (this.isPageVisible()) {
          this.onPageVisibilityChangeSource.next(true);
          this.onPageVisibleSource.next();
          return;
        }
        this.onPageVisibilityChangeSource.next(false);
        this.onPageHiddenSource.next();
      },
      false,
    );
  }
}
